import React, { PropsWithChildren } from 'react';
import { ModuleTopBar, Box, Flex, Grid } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import FlowProductsBottomBar from '@flows/src/components/flow-products/FlowProductsBottomBar';
import FlowProductsAnvaSidebar from '@flows/src/components/flow-products/FlowProductsAnvaSidebar';
import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useParams } from 'react-router';

const FlowProductsLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();
  const { flowId } = useParams<{ flowId: string }>();

  const getBackText = () => {
    if (window.location.pathname.includes('basket')) {
      return t('BACK-TO-OVERVIEW');
    }
    return t('BACK-TO-DASHBOARD');
  };
  const getPreviousUrl = () => {
    const searchParams = window.location.search;
    if (window.location.pathname.includes('basket')) {
      return `${FLOWS_PRODUCTS_PATH}/${flowId}/overview${searchParams}`;
    }
    return `/dashboard${searchParams}`;
  };

  return (
    <Grid
      templateColumns={{ base: 'auto 1fr' }}
      w="100%"
      h="100%"
      position="relative"
    >
      <FlowProductsAnvaSidebar />
      <Grid
        templateRows="auto 1fr auto"
        position="relative"
        overflow-y="auto"
        flexGrow="1"
      >
        <Box position="sticky" top="0" bg="white" zIndex="1">
          <ModuleTopBar
            backRef={getPreviousUrl()}
            title={t('CONVERSATIONS_REPORT-CREATION_PRODUCT-SELECTION')}
            backText={getBackText()}
          />
        </Box>
        <Flex flexDirection="column" w="100%" align="center" flexGrow="1">
          {children}
        </Flex>
        <FlowProductsBottomBar
          previousUrl={getPreviousUrl()}
          backText={getBackText()}
        />
      </Grid>
    </Grid>
  );
};

export default FlowProductsLayout;
